import React, { FunctionComponent, useState } from "react";
import Loader from "react-loader-spinner";
import { DARK_COLOR } from "../../../../constants/colors";

interface ImageCardPickedProps {
  url: string;
  isMe: boolean;
  isCorrect: boolean;
  username: string;
}

const ImageCardPicked: FunctionComponent<ImageCardPickedProps> = ({
  url,
  isMe,
  isCorrect,
  username
}) => {
  const [loading, setLoading] = useState(true);
  return (
    <div>
      <div
        style={
          isCorrect
            ? { fontWeight: "bold", color: "black" }
            : { color: "white" }
        }
      >
        {username} {isMe ? "(you)" : isCorrect ? "(correct)" : ""}
      </div>
      <div>
        {loading && (
          <div className="ImageCardPickedHeight">
            <Loader
              color={DARK_COLOR}
              type="MutatingDots"
              height={100}
              width={100}
            />
          </div>
        )}
        <img
          onLoad={() => setLoading(false)}
          style={{ width: "100%", borderRadius: 10 }}
          src={url}
          alt="icon"
        />
      </div>
    </div>
  );
};
export default ImageCardPicked;
